import { render } from "./Loading.vue?vue&type=template&id=2845540b&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=2845540b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2845540b"

export default script